import React from 'react';

import styles from './Logo.m.sass';

import {Link} from 'react-router';
import BrandLogo from '-!svg-react-loader?name=BrandLogo!./assets/logo.svg';

export default function Logo() {
  return (
    <Link to='/' className={styles.logo}>
      <BrandLogo className={styles.logoImage} alt="Primecarry"/>
    </Link>
  );
}



// WEBPACK FOOTER //
// ./components/logo/Logo.js